module.exports = __webpack_public_path__ + "fonts/FilsonPro-Light.949bd67.woff2";